(function () {
  const U = window.UIX = {};
  const Core = window.RB.Core;

  const APP = {
    screen: "menu",
    pregame: null,
    game: null,
    state: null,
    viewIndex: null,
    selection: null,
    peek: null,
    moveSel: null,
    picked: [],
    assign: {},
    error: null,
    menu: null,
    viewAs: "auto",
    ai: [false, false],
    aiTimer: null,
    aiMoves: 0,
    aiTurn: -1,
    aiDelay: 350,
    nativePending: null,
    nativeNote: null,
    nativeInfo: null,
    builder: null,
    builderPushed: false,
    showLog: false,
    showManual: false,
    logDetail: true,
    logOpen: {},
    showReplay: false,
    trigOrderQueue: [],
    trigOrderSig: null,
    trigAutoPd: null,
    prioGlow: "soft",
    drawer: false,
    holdPass: false,
    modalMin: false,
    modalMinPd: null,
    manualPay: false,
    payActs: [],
    payPd: null,
    autoPayPd: null,
    net: null,
    seat: null,
    mode: "play",
    boardSkin: "arena",
    watch: null,
  };
  window.APP = APP;

  const LOG_KEY = "riftbound-show-log";

  function setShowLog(v) {
    APP.showLog = !!v;
    try { localStorage.setItem(LOG_KEY, APP.showLog ? "1" : "0"); } catch (e) { }
    U.render();
  }

  const LOG_DETAIL_KEY = "riftbound-log-detail";

  function setLogDetail(v) {
    APP.logDetail = !!v;
    try { localStorage.setItem(LOG_DETAIL_KEY, APP.logDetail ? "1" : "0"); } catch (e) { }
    U.render();
  }

  const SHOW_MANUAL_KEY = "riftbound-show-manual";

  function setShowManual(v) {
    APP.showManual = !!v;
    try { localStorage.setItem(SHOW_MANUAL_KEY, APP.showManual ? "1" : "0"); } catch (e) { }
    U.render();
  }

  function flashBoardCard(iid, on) {
    if (!iid || typeof document === "undefined") return;
    const nodes = document.querySelectorAll("[data-iid='" + iid + "']");
    for (let i = 0; i < nodes.length; i++) nodes[i].classList.toggle("groupfocus", !!on);
  }

  const BOARD_SKIN_KEY = "riftbound-board-skin";

  function setBoardSkin(v) {
    APP.boardSkin = v === "arena" ? "arena" : "classic";
    try { localStorage.setItem(BOARD_SKIN_KEY, APP.boardSkin); } catch (e) { }
    if (RB.Anim) RB.Anim.flush();
    U.render();
  }

  const PRIO_GLOW_KEY = "riftbound-prio-glow";
  const PRIO_GLOWS = ["soft", "edge", "strong", "frame", "wave", "off"];

  function localDecision(state) {
    const pd = state && state.pending;
    if (!pd || pd.player === undefined || !live() || state.over) return null;
    if (APP.ai[pd.player]) return null;
    if (APP.net && pd.player !== APP.seat) return null;
    return pd;
  }

  function passAvailable(state) {
    const pd = localDecision(state);
    return !!pd && (pd.kind === "focus" || pd.kind === "respond") && !animBusy();
  }

  function setHoldPass(on) {
    APP.holdPass = !!on;
    if (typeof document !== "undefined" && document.body && document.body.classList) {
      document.body.classList.toggle("holdpass", APP.holdPass);
    }
  }

  function drainHoldPass() {
    if (!APP.holdPass || !passAvailable(APP.state)) return;
    const pd = APP.state.pending;
    setTimeout(function () {
      if (APP.holdPass && APP.state.pending === pd && passAvailable(APP.state)) dispatch({ type: "PASS", player: pd.player });
    }, 0);
  }

  function modalMinimized(state) {
    if (!APP.modalMin) return false;
    if (APP.modalMinPd !== state.pending) { APP.modalMin = false; APP.modalMinPd = null; return false; }
    return true;
  }

  const MODAL_ANIM_MS = 240;

  function modalEl() {
    return document.getElementById("choicemenu") || document.querySelector("#arena .arpanel");
  }

  function tabTarget() {
    const tab = document.getElementById("modaltab");
    if (tab) { const t = tab.getBoundingClientRect(); return { x: t.left + t.width / 2, y: t.top + 8 }; }
    return { x: window.innerWidth / 2, y: window.innerHeight - 10 };
  }

  function animOn() {
    return !!(RB.Anim && RB.Anim.speed !== 0 && typeof document !== "undefined" && document.body && document.body.animate);
  }

  function flyModalToTab(m) {
    const r = m.getBoundingClientRect();
    if (!r.width) return;
    const ghost = m.cloneNode(true);
    ghost.classList.add("modalghost");
    if (!ghost.id) ghost.classList.add("arpanelghost");
    ghost.style.position = "fixed";
    ghost.style.left = r.left + "px";
    ghost.style.top = r.top + "px";
    ghost.style.width = r.width + "px";
    ghost.style.height = r.height + "px";
    ghost.style.margin = "0";
    ghost.style.transform = "none";
    ghost.style.transformOrigin = "50% 100%";
    ghost.style.pointerEvents = "none";
    ghost.style.zIndex = "70";
    ghost.style.overflow = "hidden";
    document.body.appendChild(ghost);
    const to = tabTarget();
    const dx = to.x - (r.left + r.width / 2);
    const dy = to.y - r.bottom;
    const a = ghost.animate([
      { transform: "none", opacity: 1 },
      { transform: "translate(" + dx + "px," + dy + "px) scale(.12, .06)", opacity: 0 },
    ], { duration: MODAL_ANIM_MS / Math.max(0.2, RB.Anim.speed), easing: "cubic-bezier(.4, 0, .8, .4)", fill: "forwards" });
    a.onfinish = function () { if (ghost.parentNode) ghost.parentNode.removeChild(ghost); };
  }

  function riseModalFromTab(m, from) {
    const r = m.getBoundingClientRect();
    if (!r.width) return;
    const dx = from.x - (r.left + r.width / 2);
    const dy = from.y - r.bottom;
    m.style.transformOrigin = "50% 100%";
    m.animate([
      { transform: "translate(" + dx + "px," + dy + "px) scale(.12, .06)", opacity: 0 },
      { transform: "none", opacity: 1 },
    ], { duration: MODAL_ANIM_MS / Math.max(0.2, RB.Anim.speed), easing: "cubic-bezier(.2, .7, .3, 1)" });
  }

  function slideTab(tab, dirIn) {
    tab.animate([
      { transform: "translate(-50%, " + (dirIn ? "100%" : "0") + ")", opacity: dirIn ? 0 : 1 },
      { transform: "translate(-50%, " + (dirIn ? "0" : "100%") + ")", opacity: dirIn ? 1 : 0 },
    ], { duration: MODAL_ANIM_MS * 0.7 / Math.max(0.2, RB.Anim.speed), easing: "ease-out", delay: dirIn ? MODAL_ANIM_MS * 0.5 / Math.max(0.2, RB.Anim.speed) : 0, fill: "backwards" });
  }

  function setModalMin(on) {
    const anim = animOn();
    let from = null;
    if (anim && on) {
      const m = modalEl();
      if (m) flyModalToTab(m);
    }
    if (anim && !on) from = tabTarget();
    APP.modalMin = !!on;
    APP.modalMinPd = on ? APP.state.pending : null;
    U.render();
    if (!anim) return;
    if (on) {
      const tab = document.getElementById("modaltab");
      if (tab) slideTab(tab, true);
    } else {
      const m = modalEl();
      if (m && from) riseModalFromTab(m, from);
    }
  }

  function setDrawer(open) {
    APP.drawer = !!open;
    U.render();
  }

  function setPrioGlow(v) {
    APP.prioGlow = PRIO_GLOWS.indexOf(v) >= 0 ? v : "soft";
    try { localStorage.setItem(PRIO_GLOW_KEY, APP.prioGlow); } catch (e) { }
    U.render();
  }

  const MANUAL_PAY_KEY = "riftbound-manual-pay";

  function setManualPay(v) {
    APP.manualPay = !!v;
    try { localStorage.setItem(MANUAL_PAY_KEY, APP.manualPay ? "1" : "0"); } catch (e) { }
    if (!APP.manualPay) clearPayActs();
    U.render();
    drainAutoPay();
  }

  function clearPayActs() {
    APP.payActs = [];
    APP.payPd = null;
  }

  function payActs() {
    const pd = APP.state && APP.state.pending;
    if (!pd || pd.kind !== "pay") return [];
    if (APP.payPd !== pd) clearPayActs();
    return APP.payActs;
  }

  function setPayActs(acts) {
    APP.payActs = acts;
    APP.payPd = APP.state.pending;
    U.render();
  }

  function autoPayable(state) {
    const pd = state && state.pending;
    if (!pd || pd.kind !== "pay") return null;
    if (APP.manualPay || !live()) return null;
    if (APP.net && pd.player !== APP.seat) return null;
    if (pd.player !== undefined && APP.ai[pd.player]) return null;
    return RB.Play.autoPayPlan(state, pd.player, pd.cost, pd.payCtx || {});
  }

  function drainAutoPay() {
    const state = APP.state;
    const pd = state && state.pending;
    if (!live() || !pd || pd.kind !== "pay") { APP.autoPayPd = null; return; }
    if (APP.autoPayPd === pd) return;
    if (!autoPayable(state)) return;
    APP.autoPayPd = pd;
    setTimeout(function () { autoPayStep(pd); }, 0);
  }

  function autoPayStep(pd) {
    if (!live() || APP.state.pending !== pd || !autoPayable(APP.state)) return;
    if (animBusy()) { APP.autoPayPd = null; return; }
    dispatch({ type: "PAY", player: pd.player, auto: true });
  }

  const REPLAY_KEY = "riftbound-show-replay";

  function setShowReplay(v) {
    APP.showReplay = !!v;
    try { localStorage.setItem(REPLAY_KEY, APP.showReplay ? "1" : "0"); } catch (e) { }
    U.render();
  }

  const MENU_KEY = "riftbound-menu-cfg";

  function menuCfg() {
    let cfg = null;
    try {
      const raw = localStorage.getItem(MENU_KEY);
      if (raw) cfg = JSON.parse(raw);
    } catch (e) { }
    if (!cfg || !cfg.seats || cfg.seats.length !== 2) {
      cfg = { seats: [{ deck: "pg-annie", ai: false }, { deck: "pg-yi", ai: true }] };
    }
    for (const seat of cfg.seats) {
      if (!RB.Decklists.get(seat.deck) && RB.Decklists.libraryReady()) seat.deck = "pg-annie";
      seat.ai = pilotOf(seat.ai);
    }
    cfg.seats[0].ai = false;
    if (FOES.indexOf(cfg.foe) < 0) cfg.foe = foeOf(cfg.seats[1].ai);
    if (NATIVE_STRENGTHS.indexOf(cfg.strength) < 0) {
      cfg.strength = typeof cfg.seats[1].ai === "string" ? cfg.seats[1].ai.slice(7) : "normal";
    }
    cfg.seats[1].ai = foePilot(cfg);
    if (OPENERS.indexOf(cfg.first) < 0) cfg.first = "roll";
    if (RB.Match.BESTS.indexOf(cfg.best) < 0) cfg.best = 1;
    return cfg;
  }

  const NATIVE_STRENGTHS = ["quick", "normal", "strong"];
  const FOES = ["ai", "native", "claude", "online"];
  const OPENERS = ["you", "roll", "foe"];

  function foeOf(ai) {
    return typeof ai === "string" ? "native" : "ai";
  }

  function foePilot(cfg) {
    if (cfg.foe === "ai") return true;
    if (cfg.foe === "native") return "native:" + cfg.strength;
    return false;
  }

  function pilotOf(v) {
    if (typeof v === "string" && v.indexOf("native:") === 0) {
      const strength = v.slice(7);
      return "native:" + (NATIVE_STRENGTHS.indexOf(strength) >= 0 ? strength : "normal");
    }
    return !!v;
  }

  function nativeStrength(p) {
    const v = APP.ai[p];
    return typeof v === "string" && v.indexOf("native:") === 0 ? v.slice(7) : null;
  }

  function nativeInfo(cb) {
    if (APP.nativeInfo) return APP.nativeInfo;
    if (APP.nativeInfo === false) return null;
    APP.nativeInfo = false;
    fetch("/api/ping").then(function (r) { return r.json(); }).then(function (j) {
      APP.nativeInfo = {
        native: j.native === true,
        presets: j.nativePresets || {},
        testbench: j.testbench === true,
        agentSeats: j.agentSeats === true,
      };
      if (cb) cb(APP.nativeInfo);
    }).catch(function () {
      APP.nativeInfo = { native: false, presets: {}, testbench: true, agentSeats: false };
      if (cb) cb(APP.nativeInfo);
    });
    return null;
  }

  function saveMenuCfg(cfg) {
    try { localStorage.setItem(MENU_KEY, JSON.stringify(cfg)); } catch (e) { }
  }

  function humanSeat() {
    if (APP.ai[0] && !APP.ai[1]) return 1;
    if (APP.ai[1] && !APP.ai[0]) return 0;
    return null;
  }

  function applyAiFromSetup() {
    const ai = (APP.game && APP.game.setup && APP.game.setup.ai) || [false, false];
    APP.ai = [pilotOf(ai[0]), pilotOf(ai[1])];
    APP.nativePending = null;
    APP.nativeNote = null;
    const h = humanSeat();
    APP.viewAs = h !== null ? h : "auto";
    APP.aiMoves = 0;
  }

  function aiStep() {
    if (APP.watch) return false;
    if (APP.screen !== "game" || !live() || !APP.game) return false;
    if (RB.Anim && !RB.Anim.idle()) return false;
    const state = APP.state;
    if (state.over || !state.pending) { APP.aiMoves = 0; return false; }
    const p = state.pending.player;
    if (p === undefined || !APP.ai[p]) { APP.aiMoves = 0; return false; }
    if (state.turn.num !== APP.aiTurn) { APP.aiTurn = state.turn.num; APP.aiMoves = 0; }
    if (++APP.aiMoves > 120) {
      APP.error = "AI stopped after 120 decisions inside one turn — it is looping. Take over manually or start a new game.";
      U.render();
      return false;
    }
    const strength = nativeStrength(p);
    if (strength) return nativeStep(state, p, strength);
    let action = null;
    try { action = RB.Brain.chooseAction(state); } catch (e) {
      APP.error = "AI error: " + e.message;
      U.render();
      return false;
    }
    if (!action) return false;
    dispatch(action);
    return true;
  }

  function nativeStep(state, p, strength) {
    if (APP.nativePending) return false;
    const game = APP.game;
    const pd = state.pending;
    const ticket = { game: game, seq: game.log.length, pd: pd, seat: p, strength: strength, since: Date.now() };
    APP.nativePending = ticket;
    U.render();
    fetch("/api/native/decide", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ setup: game.setup, log: game.log, seat: p, strength: strength, deckId: (game.setup.decks || [])[p] || null }),
    }).then(function (r) {
      return r.json().then(function (j) { return r.ok && j.ok ? j : Promise.reject(new Error(j.error || ("HTTP " + r.status))); });
    }).then(function (j) {
      if (!nativeStillWanted(ticket)) return;
      APP.nativePending = null;
      APP.nativeNote = null;
      if (!j.action || typeof j.action !== "object") throw new Error("the native player returned no action");
      dispatch(j.action);
      if (APP.error) throw new Error(APP.error);
    }).catch(function (e) {
      if (!nativeStillWanted(ticket)) return;
      APP.nativePending = null;
      console.warn("[native] falling back to the heuristic AI: " + e.message);
      APP.nativeNote = "Native player unavailable (" + e.message + "), the heuristic AI played instead.";
      let action = null;
      try { action = RB.Brain.chooseAction(APP.state); } catch (e2) { }
      if (action) dispatch(action);
      else U.render();
    });
    return true;
  }

  function nativeStillWanted(ticket) {
    if (APP.nativePending !== ticket) return false;
    if (APP.screen !== "game" || !live() || APP.game !== ticket.game) { APP.nativePending = null; return false; }
    if (APP.game.log.length !== ticket.seq || APP.state.pending !== ticket.pd) { APP.nativePending = null; return false; }
    if (!nativeStrength(ticket.seat)) { APP.nativePending = null; return false; }
    return true;
  }

  function maybeAI() {
    if (APP.watch) { U.watchTick(); return; }
    if (APP.screen !== "game" || !live() || !APP.game) return;
    if (RB.Anim && !RB.Anim.idle()) return;
    const state = APP.state;
    if (!state || state.over || !state.pending) { APP.aiMoves = 0; return; }
    const p = state.pending.player;
    if (p === undefined || !APP.ai[p]) { APP.aiMoves = 0; return; }
    if (APP.aiTimer || APP.nativePending) return;
    APP.aiTimer = setTimeout(function () {
      APP.aiTimer = null;
      aiStep();
    }, APP.aiDelay);
  }

  const BACK_SVG = "<svg width='__S__' height='__S__' viewBox='0 0 24 24' fill='none' stroke='#c9a34f' stroke-width='1.2'><path d='M12 2l8.7 5v10L12 22l-8.7-5V7z'></path><circle cx='12' cy='12' r='3.4'></circle><path d='M12 5.4v3.2M12 15.4v3.2M6.3 8.7l2.8 1.6M14.9 13.7l2.8 1.6M17.7 8.7l-2.8 1.6M9.1 13.7l-2.8 1.6'></path></svg>";

  function backSvg(size) { return BACK_SVG.split("__S__").join(String(size)); }

  function live() { return APP.viewIndex === null; }

  function viewPlayer(state) {
    if (APP.viewAs === 0 || APP.viewAs === 1) return APP.viewAs;
    const pd = state.pending;
    if (pd && pd.player !== undefined) return pd.player;
    return state.turn.player;
  }

  const el = window.UIDOM.el;
  const esc = window.UIDOM.esc;
  const iconize = window.UIDOM.iconize;
  const fmtText = window.UIDOM.fmtText;
  const plainText = window.UIDOM.plainText;

  function pcls(p) { return p === 0 ? "cr" : "az"; }
  function stripCls(p) { return p === 0 ? "mine" : "opp"; }

  const ART_KIND_W = { bf: 1400, rune: 170, art: 120 };

  function artStyle(e, state, iid, kind, cssWidth) {
    artStyleCard(e, Core.card(state, iid), kind, cssWidth);
  }

  function artStyleCard(e, c, kind, cssWidth) {
    if (!c) return;
    e.style.backgroundImage = RB.artCssAt(c, cssWidth || ART_KIND_W[kind] || 112);
    if (kind === "bf") {
      e.style.backgroundSize = "115% auto";
      e.style.backgroundPosition = "61% 30%";
    } else if (kind === "rune") {
      e.style.backgroundSize = "auto 192%";
      e.style.backgroundPosition = "50% 17%";
    } else if (kind === "full") {
      e.style.backgroundSize = "cover";
      e.style.backgroundPosition = "center";
    } else {
      e.style.backgroundSize = "cover";
      e.style.backgroundPosition = "center";
    }
  }

  function dispatch(action) {
    if (APP.net) return APP.net.dispatch(action);
    return applyAction(action);
  }

  function applyAction(action) {
    if (!live()) {
      APP.error = "Viewing a replay - press 'Continue from here' to branch first.";
      U.render();
      return;
    }
    const r = Kernel.dispatch(APP.game, APP.state, action);
    if (!r.ok) {
      APP.error = r.error;
      U.render();
      return;
    }
    APP.error = null;
    const prevState = APP.state;
    APP.state = r.state;
    APP.picked = [];
    APP.assign = {};
    APP.moveSel = null;
    clearPayActs();
    if (!APP.net && !APP.watch) saveLocal();
    const aiActor = action.player !== undefined && APP.ai[action.player];
    if (RB.Anim) {
      U.IDLE_RENDER = false;
      if (!aiActor) RB.Anim.flush();
      RB.Anim.capture(prevState, APP.state);
      U.IDLE_RENDER = true;
    }
    U.render();
    drainTrigOrder();
    drainAutoPay();
    if (RB.Anim) {
      RB.Anim.notify(action, r.events, APP.state, {
        aiActor: aiActor,
        prevState: prevState,
        ai: APP.ai.slice(),
        viewers: [viewPlayer(prevState), viewPlayer(APP.state)],
      });

      if (animBusy()) U.render();
    }
  }

  function applyRemoteState(action, state, events) {
    APP.error = null;
    const prevState = APP.state;
    APP.state = state;
    APP.picked = [];
    APP.assign = {};
    APP.moveSel = null;
    clearPayActs();
    if (RB.Anim) {
      U.IDLE_RENDER = false;
      RB.Anim.flush();
      RB.Anim.capture(prevState, APP.state);
      U.IDLE_RENDER = true;
    }
    U.render();
    drainTrigOrder();
    drainAutoPay();
    if (RB.Anim) {
      RB.Anim.notify(action, events || [], APP.state, {
        aiActor: false,
        prevState: prevState,
        ai: [false, false],
        viewers: [viewPlayer(prevState), viewPlayer(APP.state)],
      });
      if (animBusy()) U.render();
    }
  }

  function drainTrigOrder() {
    const pd = APP.state && APP.state.pending;
    if (!pd || pd.tag !== "orderTriggers") {
      APP.trigOrderQueue = [];
      APP.trigOrderSig = null;
      return;
    }
    if (!APP.trigOrderQueue.length || APP.trigAutoPd === pd) return;
    if (APP.net && pd.player !== APP.seat) return;
    const optIdx = pd.options.indexOf(APP.trigOrderQueue[0]);
    if (optIdx < 0) { APP.trigOrderQueue = []; return; }
    APP.trigAutoPd = pd;
    APP.trigOrderQueue.shift();
    setTimeout(function () {
      if (APP.state.pending === pd) dispatch({ type: "CHOOSE", player: pd.player, optionIdx: optIdx });
    }, 0);
  }

  function loadGame(game, label) {
    if (APP.watch && U.watchStop) U.watchStop();
    RB.setArtOverrides({});
    window.UIDOM.dismissNotice();
    const warn = Kernel.checkVersion(game);
    try {
      const state = Kernel.computeState(game);
      APP.game = game;
      APP.state = state;
      APP.viewIndex = null;
      APP.error = null;
      if (warn) window.UIDOM.showNotice(warn);
      return true;
    } catch (e) {
      const salvage = Kernel.replaySafe(game);
      if (!salvage.state) {
        APP.error = (label || "That game") + " could not be loaded: " + salvage.error;
        return false;
      }
      const dropped = game.log.length - salvage.upto;
      game.log = game.log.slice(0, salvage.upto);
      APP.game = game;
      APP.state = salvage.state;
      APP.viewIndex = null;
      APP.error = (label || "The saved game") + " was recorded on an older rules version: " +
        dropped + " later action" + (dropped === 1 ? "" : "s") +
        " no longer replay (" + salvage.error + "). Play resumes from action " + salvage.upto + ".";
      return true;
    }
  }

  const AUTOSAVE_AT_KEY = "riftbound-sim-autosave-at";

  const SNAP_EVERY = 32;
  const snapshots = new WeakMap();

  function stateAt(game, idx) {
    let snaps = snapshots.get(game);
    if (!snaps) { snaps = {}; snapshots.set(game, snaps); }
    let base = Math.floor(idx / SNAP_EVERY) * SNAP_EVERY;
    while (base > 0 && !snaps[base]) base -= SNAP_EVERY;
    let state = base > 0 ? Kernel.deepClone(snaps[base]) : Kernel.computeState(game, 0);
    for (let i = base; i < idx; i++) {
      state = Kernel.step(state, game.log[i]);
      if ((i + 1) % SNAP_EVERY === 0 && !snaps[i + 1]) snaps[i + 1] = Kernel.deepClone(state);
    }
    return state;
  }

  function jumpTo(idx) {
    if (RB.Anim) RB.Anim.flush();
    try {
      if (idx >= APP.game.log.length) {
        APP.viewIndex = null;
        APP.state = stateAt(APP.game, APP.game.log.length);
      } else {
        APP.viewIndex = idx;
        APP.state = stateAt(APP.game, idx);
      }
      APP.error = null;
    } catch (e) {
      loadGame(APP.game, "This game");
    }
    APP.picked = [];
    APP.assign = {};
    APP.moveSel = null;
    APP.logOpen = {};
    APP.selection = null;
    U.render();
  }

  function rewindTo(log) {
    if (RB.Anim) RB.Anim.flush();
    snapshots.delete(APP.game);
    APP.game.log = log.slice();
    APP.state = Kernel.computeState(APP.game);
    APP.viewIndex = null;
    APP.error = null;
    APP.picked = [];
    APP.assign = {};
    APP.moveSel = null;
    APP.selection = null;
  }

  function branchHere() {
    if (live()) return;
    snapshots.delete(APP.game);
    APP.game.log = APP.game.log.slice(0, APP.viewIndex);
    APP.viewIndex = null;
    APP.state = Kernel.computeState(APP.game);
    saveLocal();
    U.render();
  }

  function saveLocal() {
    if (window.TB && TB.run) return;
    try {
      localStorage.setItem("riftbound-sim-autosave", JSON.stringify(APP.game));
      localStorage.setItem(AUTOSAVE_AT_KEY, String(Date.now()));
    } catch (e) { }
    if (U.saveMatch) U.saveMatch();
  }

  function newGame(setup) {
    if (APP.watch && U.watchStop) U.watchStop();
    if (window.TB) TB.run = null;
    RB.setArtOverrides({});
    window.UIDOM.dismissNotice();
    APP.game = Kernel.newGame(setup);
    APP.state = Kernel.computeState(APP.game);
    APP.viewIndex = null;
    APP.logOpen = {};
    APP.selection = null;
    APP.error = null;
    APP.screen = "game";
    applyAiFromSetup();
    saveLocal();
    U.render();
  }

  function exportGame() {
    const blob = new Blob([JSON.stringify(APP.game, null, 1)], { type: "application/json" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "riftbound-game-" + Date.now() + ".json";
    a.click();
  }

  function importGame(file) {
    const rd = new FileReader();
    rd.onload = function () {
      try {
        const g = JSON.parse(rd.result);
        if (!g.setup || !g.log) throw new Error("not a game file");
        if (!loadGame(g, "The imported game")) { U.render(); return; }
        APP.screen = "game";
        applyAiFromSetup();
        APP.selection = null;
        saveLocal();
        U.render();
      } catch (e) {
        APP.error = "Import failed: " + e.message;
        U.render();
      }
    };
    rd.readAsText(file);
  }

  function cardTitle(state, iid) {
    const c = Core.card(state, iid);
    if (!c) return "";
    const parts = [c.name];
    if (c.energy !== undefined && c.energy !== null) parts.push("Cost: " + c.energy + (c.power ? " + " + c.power + " power (" + (c.domains || []).join("/") + ")" : ""));
    if (c.might !== null && c.might !== undefined) parts.push("Might: " + c.might);
    if (c.text) parts.push(plainText(c.text));
    return parts.join("\n");
  }

  const legalMemo = new WeakMap();

  function computeLegal(state) {
    if (!live() || !state.pending) return null;
    if (APP.net && state.pending.player !== APP.seat) return null;
    const k = state.pending.kind;
    if (["act", "focus", "respond"].indexOf(k) < 0) return null;
    if (legalMemo.has(state)) return legalMemo.get(state);
    const legal = enumerateLegal(state);
    legalMemo.set(state, legal);
    return legal;
  }

  function enumerateLegal(state) {
    try {
      const acts = Kernel.enumerateActions(state);
      const play = {};
      const abil = {};
      for (const a of acts) {
        if (a.type === "PLAY_CARD" || a.type === "HIDE") play[a.iid] = 1;
        if (a.type === "ACTIVATE" && a.ability !== undefined) abil[a.iid + ":" + a.ability] = 1;
      }
      return { play: play, abil: abil };
    } catch (e) {
      return null;
    }
  }

  U.LEGAL = null;

  U.IDLE_RENDER = true;
  function animBusy() {
    return !!(RB.Anim && RB.Anim.speed && !RB.Anim.idle());
  }

  Object.assign(U, { localDecision: localDecision, passAvailable: passAvailable, setHoldPass: setHoldPass, drainHoldPass: drainHoldPass, modalMinimized: modalMinimized, setModalMin: setModalMin, setDrawer: setDrawer, PRIO_GLOW_KEY: PRIO_GLOW_KEY, PRIO_GLOWS: PRIO_GLOWS, setPrioGlow: setPrioGlow, LOG_DETAIL_KEY: LOG_DETAIL_KEY, setLogDetail: setLogDetail, SHOW_MANUAL_KEY: SHOW_MANUAL_KEY, setShowManual: setShowManual, flashBoardCard: flashBoardCard, BOARD_SKIN_KEY: BOARD_SKIN_KEY, setBoardSkin: setBoardSkin, applyRemoteState: applyRemoteState, setShowLog: setShowLog, setShowReplay: setShowReplay, REPLAY_KEY: REPLAY_KEY, MANUAL_PAY_KEY: MANUAL_PAY_KEY, setManualPay: setManualPay, payActs: payActs, setPayActs: setPayActs, autoPayable: autoPayable, drainAutoPay: drainAutoPay, autoPayStep: autoPayStep, menuCfg: menuCfg, saveMenuCfg: saveMenuCfg, FOES: FOES, foePilot: foePilot, pilotOf: pilotOf, nativeStrength: nativeStrength, nativeInfo: nativeInfo, NATIVE_STRENGTHS: NATIVE_STRENGTHS, OPENERS: OPENERS, applyAiFromSetup: applyAiFromSetup, aiStep: aiStep, maybeAI: maybeAI, backSvg: backSvg, live: live, viewPlayer: viewPlayer, el: el, esc: esc, fmtText: fmtText, plainText: plainText, pcls: pcls, stripCls: stripCls, artStyle: artStyle, artStyleCard: artStyleCard, dispatch: dispatch, applyAction: applyAction, loadGame: loadGame, jumpTo: jumpTo, rewindTo: rewindTo, branchHere: branchHere, saveLocal: saveLocal, newGame: newGame, exportGame: exportGame, importGame: importGame, cardTitle: cardTitle, computeLegal: computeLegal, animBusy: animBusy, LOG_KEY: LOG_KEY, AUTOSAVE_AT_KEY: AUTOSAVE_AT_KEY });
})();
